import type { ReactNode } from 'react';
import { useEffect } from 'react';

export interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: number;
  side?: 'left' | 'right';
}

export function Drawer({
  open,
  onClose,
  children,
  width = 520,
  side = 'right',
}: DrawerProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 50 }}>
      <div
        onClick={onClose}
        style={{
          position: 'absolute',
          inset: 0,
          background: 'var(--apm-overlay)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          [side]: 0,
          width,
          background: 'var(--apm-card)',
          borderLeft: side === 'right' ? '1px solid var(--apm-line)' : 'none',
          borderRight: side === 'left' ? '1px solid var(--apm-line)' : 'none',
          boxShadow: 'var(--apm-shadow-lg)',
          display: 'flex',
          flexDirection: 'column',
          animation: `apm-slide-${side} .18s ease-out`,
        }}
      >
        {children}
      </div>
    </div>
  );
}
